import '../../assets/scss/common/carousel.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useRef, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';


export default function OptionTile({images, imageBaseUrl, productName})
{
    // override prev/next image icon position - this may need moving out to each page that uses a carousel - only slide out panel using it for now
    const imageIndicatorsRef = useRef(null);

    useEffect(() => {

        if (imageIndicatorsRef.current && imageIndicatorsRef.current.element.children[2] && imageIndicatorsRef.current.element.children[3])
        {
            imageIndicatorsRef.current.element.children[2].style.cssText = "left: calc(50% - " + ((imageIndicatorsRef.current.element.children[0].offsetWidth / 2) - 15) + "px);";
            imageIndicatorsRef.current.element.children[3].style.cssText = "left: calc(50% + " + ((imageIndicatorsRef.current.element.children[0].offsetWidth / 2) - 35) + "px);";
        }
    });

    return (
        <Carousel ref={imageIndicatorsRef} interval={null} indicators={images.length > 1 ? true : false} indicatorLabels={[""]} className={images.length > 1 ? "mb-4 mb-xl-5" : null}
                                            prevIcon={<span aria-hidden="true"><FontAwesomeIcon icon={icon({ name: 'chevron-left', style: 'solid' })} className={"prev-image-icon " + (images.length < 2 ? "d-none" : "")}/></span>}
                                            nextIcon={<span aria-hidden="true"><FontAwesomeIcon icon={icon({ name: 'chevron-right', style: 'solid' })} className={"next-image-icon " + (images.length < 2 ? "d-none" : "")}/></span>}
        >
            {
                images.map((imageUrl, index) =>
                {
                    return (
                        <Carousel.Item key={"image_" + index} className="text-center">
                            <img src={imageBaseUrl + imageUrl + "?width=600&height=600&scale=both"} className="offcanvas-product-image w-100 mb-2 mx-auto" alt={productName + " image " + (index + 1)} />
                        </Carousel.Item>
                    )
                })
            }
        </Carousel>
    );
}